<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" header="商家信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="mid">
                <span slot="label"><a-tooltip>银联商户号<template slot="title">银联商户号该属性审核通过才有</template></a-tooltip>        </span>
                <a-input v-model="form.mid"  :maxLength="8"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="tid">
                <span slot="label"><a-tooltip>银联终端号<template slot="title">银联商户号该属性审核通过才有</template></a-tooltip>        </span>
                <a-input v-model="form.tid"  :maxLength="8" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merNo">
                <span slot="label"><a-tooltip>企业商户号<template slot="title">企业商户号该属性审核通过才有</template></a-tooltip>        </span>
                <a-input v-model="form.merNo"  :maxLength="8" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>

      </a-collapse>


      <radio-branch-select-form ref="RadioBranchSelectForm" @branchSelect="indexBranchSelect"></radio-branch-select-form>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getExtraApplyUms, updateExtraApplyUms} from '@/api/merchant/extraApplyChinaums'
import {getApplyByMerchantId} from '@/api/merchant/merchantApply'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import Editor from '@/components/Editor'
import {listIndustry} from "@/api/merchant/industry";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import RadioBranchSelectForm from '@/views/merchant/branch/modules/RadioSelectForm'
import FeeRateForm from "@/views/merchant/lakalaApply/modules/FeeRateForm.vue";
import {downLoadExcel} from "@/utils/excelDownload";

export default {
  name: 'CreateForm',
  props: {
    merchantId:{
      type: String,
      required: true
    },
    merchantType:{
      type: Number,
      required: true,
      default: 1
    }
  },
  components: {
    FeeRateForm,
    OssUploadSingle,
    CustomDictTag,
    RadioBranchSelectForm,
    Editor
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '请填写真实信息,否则将进件不成功',
      loading: '',
      activeKey: [1, 2, 3, 4, 5],
      areaList: [],
      areaSelected: [],
      industryList: [],
      industrySelected: [],
      // 表单参数
      form: {
        id: null,
        merchantId: this.merchantId,
        tid: null,
        mid: null,
        merNo: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        acctTypeCode: [{ required: true, message: '结算账户性质'+this.$t('不能为空'), trigger: 'change' }],
        posType: [{ required: true, message: '进件POS类型'+this.$t('不能为空'), trigger: 'change' }],
        orgCode: [{ required: true, message: '机构代码'+this.$t('不能为空'), trigger: 'change' }],
        merRegName: [{ required: true, message: '商户注册名称'+this.$t('不能为空'), trigger: 'blur' }],
        merBizName: [{ required: true, message: '商户简称'+this.$t('不能为空'), trigger: 'blur' }],
        merAreaxId: [{ required: false, message: '商户所在地'+this.$t('不能为空'), trigger: 'change' }],
        merRegDistCode: [{ required: true, message: '商户所在地'+this.$t('不能为空'), trigger: 'change' }],
        merBlis: [{ required: this.merchantType===1, message: '营业执照号'+this.$t('不能为空'), trigger: 'blur' }],
        merBlisName: [{ required: this.merchantType===1, message: '营业执照名称'+this.$t('不能为空'), trigger: 'blur' }],
        merBlisStDt: [{ required: this.merchantType===1, message: '营业执照开始日期'+this.$t('不能为空'), trigger: 'change' }],
        merBlisExpDt: [{ required: this.merchantType===1, message: '营业执照有效期'+this.$t('不能为空'), trigger: 'change' }],
        merRegAddr: [{ required: true, message: '商户注册地址'+this.$t('不能为空'), trigger: 'change' }],
        mccCode: [{ required: true, message: '商户行业'+this.$t('不能为空'), trigger: 'change' }],
        merBusiContent: [{ required: true, message: '商户经营内容'+this.$t('不能为空'), trigger: 'change' }],
        larName: [{ required: '结算人姓名'+this.$t('不能为空'), trigger: 'change' }],
        larIdType: [{ required: true, message: '结算人身份证类型'+this.$t('不能为空'), trigger: 'change' }],
        larIdcard: [{ required: true, message: '结算人身份证号'+this.$t('不能为空'), trigger: 'change' }],
        larIdcardStDt: [{ required: true, message: '结算人身份证开始日期'+this.$t('不能为空'), trigger: 'change' }],
        larIdcardExpDt: [{ required: true, message: '结算人身份证结束日期'+this.$t('不能为空'), trigger: 'change' }],
        merContactMobile: [{ required: true, message: '商户联系人手机号'+this.$t('不能为空'), trigger: 'blur' }],
        merContactName: [{ required: true, message: '商户联系人姓名'+this.$t('不能为空'), trigger: 'blur' }],
        merContactEmail: [{ required: true, message: '商户联系人邮箱'+this.$t('不能为空'), trigger: 'blur' }],
        shopName: [{ required: true, message: '商铺名称'+this.$t('不能为空'), trigger: 'change' }],
        shopDistCode: [{ required: true, message: '商铺所在地'+this.$t('不能为空'), trigger: 'change' }],
        shopAddr: [{ required: true, message: '商铺地址'+this.$t('不能为空'), trigger: 'change' }],
        shopContactName: [{ required: true, message: '商铺联系人姓名'+this.$t('不能为空'), trigger: 'change' }],
        shopContactMobile: [{ required: true, message: '商铺联系人手机号'+this.$t('不能为空'), trigger: 'change' }],
        openingBankCode: [{ required: true, message: '结算账户开户行代码'+this.$t('不能为空'), trigger: 'change' }],
        openingBankName: [{ required: true, message: '结算账户开户行名称'+this.$t('不能为空'), trigger: 'change' }],
        clearingBankCode: [{ required: true, message: '结算账户清算行代码'+this.$t('不能为空'), trigger: 'change' }],
        acctNo: [{ required: true, message: '结算账户号'+this.$t('不能为空'), trigger: 'change' }],
        acctName: [{ required: true, message: '结算账户名称'+this.$t('不能为空'), trigger: 'change' }],
        settlePeriod: [{ required: true, message: '结算周期'+this.$t('不能为空'), trigger: 'change' }],
        feeDataList: [{ required: true, message: '费率'+this.$t('不能为空'), trigger: 'change' }],
        businessLicenseImg: [{ required: this.merchantType===1, message: '营业执照'+this.$t('不能为空'), trigger: 'change' }],
        legalCardNational: [{ required: true, message: '法人身份证国徽面'+this.$t('不能为空'), trigger: 'change' }],
        legalCardFace: [{ required: true, message: '法人身份证人像面'+this.$t('不能为空'), trigger: 'change' }],
        cooperationAgreement: [{ required: true, message: '合作协议'+this.$t('不能为空'), trigger: 'change' }],
        bankCardImg: [{ required: true, message: '银行卡'+this.$t('不能为空'), trigger: 'change' }],
        doorImg: [{ required: true, message: '商户门头照'+this.$t('不能为空'), trigger: 'change' }],
        interiorImg: [{ required: true, message: '商铺内部照片'+this.$t('不能为空'), trigger: 'change' }],
      }
    }
  },
  filters: {},
  created() {
    this.getIndustryList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    makeRequiredIfMerType1(label){
      return (rule, value, callback) => {
        if (this.merchantType === 1 && (!value || value === '')) {
          callback(new Error(label + this.$t('不能为空')))
        } else {
          callback()
        }
      }
    },
    onAreaChange(value, selectedOptions) {
      this.form.merAreaxId = value[2]
      this.form.merRegDistCode = selectedOptions[2].lakalaCode
    },

    getIndustryList() {
      listIndustry({merchantType:this.merchantType}).then(response => {
        this.industryList = response.data
      })
    },
    onIndustryChange(value, selectedOptions) {
      this.form.mccCode = selectedOptions[1].unionPayMcc
    },
    merBlisExpDtLong() {
      this.form.merBlisExpDt= '9999-12-31'
    },

    sameSettleLegal() {
      this.form.acctIdType = this.form.larIdType
      this.form.acctIdcard = this.form.larIdcard
      this.form.acctIdDt = this.form.larIdcardExpDt
      this.form.settleCardFace = this.form.legalCardFace
      this.form.settleCardNational = this.form.legalCardNational
    },

    getBranchName() {
      if (this.form.openingBankName) {
        return this.form.openingBankName
      } else {
        return this.$t('请选择')+'结算账户开户行名称'
      }
    },
    indexBranchSelect(record) {
      console.log('选中了银行:',record)
      this.form.openingBankName = record.name;
      this.form.openingBankCode = record.code;
      this.form.clearingBankCode = record.clearingCode;
    },

    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        merchantId: this.merchantId,
        tid: null,
        mid: null,
        merNo: null,
      }
      this.areaSelected= []

    },

    indexRateType(list) {
      this.form.feeDataList = list
      this.getRateTypeName()
    },
    getRateTypeName() {
      if (this.form.feeDataList && this.form.feeDataList.length>0) {
        let str = ''
        this.form.feeDataList.forEach(e=>{
          str += e.feeRateTypeName  +":"+ e.feeRatePct + '%,   '
        })
        return str.length > 40 ? str.substring(0, 40) + '...' : str
      } else {
        return '配置费率信息'
      }
    },

    /** 新增按钮操作 */
    handleAdd(merchantId, total) {
      this.reset()
      this.formType = 1
        //查询进件记录
      getApplyByMerchantId({"id": merchantId}).then(response => {
        if (total===0) {
          this.form.merRegName = response.data.merchantName;
          this.form.merBizName = response.data.merchantName
          this.form.merRegAddr = response.data.merchantAddress
          this.form.merBlis = response.data.businessLicenceNo
          this.form.larName = response.data.contactName
          this.form.larIdcard = response.data.contactCardNo
          this.form.merContactName = response.data.contactName
          this.form.merContactEmail = response.data.contactEmail
        }
      })
      this.open = true;
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getExtraApplyUms({"id": id}).then(response => {
        this.form = response.data
        this.open = true
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateExtraApplyUms(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message, 3);
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less">
.goods-collapse > .ant-collapse-header {
  color: #0e75d3 !important;
  background: #e8eef9;
}
</style>
